import React from 'react';
const facts = [{
  value: '6 + 5',
  label: 'Volumes & bonuses'
}, {
  value: '59',
  label: 'Ready-Run Sessions'
}, {
  value: '29',
  label: 'Printable worksheets'
}, {
  value: '0',
  label: 'Classes planned from scratch'
}];
export function SocialProofBar() {
  return <section className="w-full bg-navy" data-id="element-207" data-mp="25su8zc8x9rjv">
      <div className="max-w-6xl mx-auto px-5 pb-14 pt-10 sm:pb-16" data-id="element-208" data-mp="25tvivde7c800">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-navy-line bg-navy-line sm:grid-cols-4" data-id="element-209" data-mp="32iusavqivfts">
          {facts.map(fact => <div key={fact.label} className="bg-navy px-4 py-5 text-center" data-id="element-210" data-mp="2xhxd8s0t71wi">
              <div className="font-display text-3xl sm:text-4xl leading-none text-gold" data-id="element-211" data-mp="2th3su8mks58d">
                {fact.value}
              </div>
              <div className="mt-1.5 text-[10px] font-bold uppercase tracking-widest text-white/60" data-id="element-212" data-mp="2ologxm84ojel">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}